<template>
  <footer>
    <div class="footer-about">
      <div>
        <div class="footer-about-iso">
          <img
            src="https://p1-a392e26b.imageflux.jp/w=91/images/logo_ISMS.png"
            alt=""
            width="91"
            height="40"
          />
          <p>
            <span>ISOを取得しています</span><br />
            当社はお客様から取得する個人情報を含めすべての情報についてISO27001に基づく管理を行い、情報のセキュリティを確保しています。
          </p>
        </div>
      </div>
    </div>

    <div class="footer-iso">
      <div>
        <span>ISOを取得しています</span>
        当社はお客様から取得する個人情報を含めすべての情報についてISO27001に基づく管理を行い、<br />情報のセキュリティを確保しています。
      </div>
    </div>

    <small class="copyright">
      Copyright &copy; 2000 WebCrew Inc. All rights reserved.
    </small>
  </footer>
</template>

<style lang="scss" scoped>
.footer-about {
  display: none;
}

.footer-iso > div {
  padding: 4% 4% 4% 37%;
  font-size: px(12);
  background: url(https://p1-a392e26b.imageflux.jp/images/logo_ISMS.png) 4%
    center no-repeat #E8F1F4;
  background-size: 30% auto;

  > span {
    display: block;
    color: #333;
    font-size: px(16.8);
    font-weight: bold;
  }
}

.copyright {
  padding: 2.5% 4% 3.5%;
  border-top: 1px solid #dcdcdc;
  display: block;
  font-size: px(12.5);
  text-align: center;
  line-height: 1.2;
  color:#FFF;
  background-color: #1C79C6;

  img {
    margin: 0 auto 1%;
    width: 50%;
    height: auto;
  }
}

@include media(pc) {
  .footer-about {
    display: block;
    background-color: #E8F1F4;

    > div {
      width: 800px;
      margin: 0 auto;
      padding: 20px 0;
      overflow: hidden;
    }
  }

  .footer-about-iso {
    img {
      padding: 3px 0;
      width: 128px;
      height: auto;
    }

    p {
      margin: -60px 0 0 170px;
      font-size: px(12.3);

      span {
        font-size: px(17);
        font-weight: bold;
      }
    }
  }

  .footer-iso {
    display: none;
  }

  .copyright {
    margin: 0 auto;
    padding: 10px 0;
    border-top: none;
    display: block;
    font-size: px(12.5);

    img {
      margin: 0 8px 0 0;
      width: 164px;
      height: 16px;
      display: inline-block;
      vertical-align: middle;
    }
  }
}
</style>
